<template>
  <div class="debtrelief-agent-contract-view">
    <nav-bar titleText="电子合同" titleWeight="bold" @goBack="goBack"></nav-bar>
    <div class="empty"></div>
    <div class="content-box">
      <div class="note" v-if="agent_contract_status == 0 || logo_contract_status == 0">注：请务必将以下合同都签署完成</div>
      <div class="content1">
        <div class="title">解债经纪人合作协议</div>
        <div class="preview" @click="showPdf = true">
          <span class="download-btn" @click.stop="downloadPdf(firstUrl)" v-show="!isiOS">下载</span>
          <div v-if="Array.isArray(pdf_src_agent)">
            <img :src="pdf_src_agent[0]" class="img" :style="imgStyle1">
          </div>
          <pdf v-else :src="pdf_src_agent" :page="1"></pdf>
          <!-- <pdf v-for="i in numPages" :key="i" :src="pdfSrc" :page="i" ></pdf> -->
          <span class="icon" v-if="agent_contract_status == 0">待签名</span>
        </div>

        <button class="sign" v-if="agent_contract_status == 0" @click="toSign(agent_contract_id, 'agent')">立即签名</button>
        <div class="signed" v-if="agent_contract_status == 1">已签名</div>
        <!-- <div class="validate" v-if="agent_contract_status == 1">有效期：2020.01.01-2020.12.31</div> -->
        <div class="validate" v-if="agent_contract_status == 1">
          有效期：{{ contract_sign_time | dateFormat }}-{{ contract_due_time | dateFormat }}</div>
      </div>
      <div class="content2">
        <div class="title">经纪人商标使用许可合同</div>
        <div class="preview" @click="showPdf2 = true">
          <span class="download-btn" @click.stop="downloadPdf(secondUrl)" v-show="!isiOS">下载</span>
          <div v-if="Array.isArray(pdf_src_logo)">
            <img :src="pdf_src_logo[0]" class="img" :style="imgStyle1">
          </div>
          <pdf v-else :src="pdf_src_logo" :page="1"></pdf>
          <span class="icon" v-if="logo_contract_status == 0">待签名</span>
        </div>
        <button class="sign" v-if="logo_contract_status == 0" @click="toSign(logo_contract_id, 'logo')">立即签名</button>
        <div class="signed" v-if="logo_contract_status == 1">已签名</div>
        <div class="validate" v-if="logo_contract_status == 1 && is_backed != 1">
          有效期：{{ logo_sign_time | dateFormat }}-{{ logo_due_time | dateFormat }}</div>
        <div class="validate" v-if="logo_contract_status == 1 && is_backed == 1">
          有效期：{{ contract_sign_time | dateFormat }}-{{ contract_due_time | dateFormat }}</div>
      </div>
    </div>

    <div class="stepper-warpper" v-if="showPdf">
      <van-stepper v-model="value" input-width="40px" step="0.2" :decimal-length="1" :disabled="isDisabled"
        @change="stepperOnchange1" />
      <div class="percent">{{percentValue}}</div>
    </div>
    <van-popup v-model="showPdf" closeable position="bottom" :style="{ height: 'calc(100% - 66px)' }">
      <div :style="pdfStyle" ref="pdfbox">
        <pdf ref="myPdfComponent" v-for="(i, j) in num_pages_agent" :key="j" :src="pdf_src_agent" :page="i"></pdf>
      </div>
      <div v-if="Array.isArray(pdf_src_agent)">
        <img v-for="(item, i) in pdf_src_agent" :src="item" class="img" :key="i" :style="imgStyle1">
      </div>
    </van-popup>

    <div class="stepper-warpper" v-if="showPdf2">
      <van-stepper v-model="value2" input-width="40px" step="0.2" :decimal-length="1" :disabled="isDisabled2"
        @change="stepperOnchange2" />
      <div class="percent">{{percentValue2}}</div>
    </div>
    <van-popup v-model="showPdf2" closeable position="bottom" :style="{ height: 'calc(100% - 66px)' }">
      <div :style="pdfStyle2" ref="pdfbox2">
        <pdf ref="myPdfComponent" v-for="(i, j) in num_pages_logo" :key="j" :src="pdf_src_logo" :page="i"></pdf>
      </div>
      <div v-if="Array.isArray(pdf_src_logo)">
        <img v-for="(item, i) in pdf_src_logo" :src="item" class="img" :key="i" :style="imgStyle2">
      </div>
    </van-popup>

    <div class="loading" v-if="loading">
      <img src="../../../assets/common/loading.gif" />
    </div>
  </div>
</template>

<script>
  import navBar from "../components/navBar";
  import pdf from "vue-pdf";
  import dsbridge from 'dsbridge';
  import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js';
  export default {
    data() {
      return {
        num_pages_agent: 0,
        num_pages_logo: 0,
        pdf_src_agent: "",
        pdf_src_logo: "",
        agent_contract_status: -1,
        logo_contract_status: -1,
        showPdf: false,
        showPdf2: false,
        value: 0,
        value2: 0,
        isDisabled: false,
        isDisabled2: false,
        pdfStyle: {
          'transform-origin': 'left top'
        },
        pdfStyle2: {
          'transform-origin': 'left top'
        },
        imgStyle1: {
          width: '100%'
        },
        imgStyle2: {
          width: '100%'
        },
        contract_sign_time: null,
        contract_due_time: null,
        logo_sign_time: null,
        logo_due_time: null,
        is_backed: -1, // 0 正常流程生成  1 后台添加（有效时间）
        loading: false,
        firstUrl: '',
        secondUrl: '',
        isiOS: false,
      }
    },
    components: {
      navBar,
      pdf,
    },
    computed: {
      percentValue() {
        return parseInt(parseFloat(this.value) * 100) + '%'
      },
      percentValue2() {
        return parseInt(parseFloat(this.value2) * 100) + '%'
      },
    },
    created() {
      let u = navigator.userAgent
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (this.$route.query.token) {
        this.$api.setToken(this.$route.query.token);
      }
      if (this.$route.query.debt_from == 'home') {
        this.loading = true
      }
      this.onLoad()
    },
    filters: {
      dateFormat(value) {
        return value.split(' ')[0].split('-').join('.')
      },
    },
    methods: {
      downloadPdf(url) {
        let u = navigator.userAgent
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        url = Array.isArray(url) ? url[0] : url
        if (isiOS) {
          let jsonParams = JSON.stringify({
            key: 'url',
            value: url
          })
          dsbridge.call("downLoadFile", jsonParams, (res) => {
            let json = JSON.parse(res);
            if (json.result == 'completed') {
              this.params(json.path, json.path, "openFile");
            } else {

            }
          });
        } else if (isAndroid) {
          this.params(url, url, 'downloadStart');
        }
      },
      goBack() {
        if (this.$route.query.gopage) {
          this.$router.push({
            path: '/debtRelief/wrDebtPersonHome'
          })
        } else {
          this.$router.go(-1)
        }

      },
      stepperOnchange1() {
        this.$nextTick(() => {
          // this.pdfStyle.width = this.percentValue
          this.pdfStyle.transform = `scale(${this.value})`
          this.imgStyle1.width = this.percentValue
          // 刷新pdf整体容器，解决IOS放大缩小后的样式混乱BUG
          this.$refs.pdfbox.style.display = 'none'
          this.isDisabled = true
          setTimeout(() => {
            // 刷新pdf整体容器，解决IOS放大缩小后的样式混乱BUG
            this.$refs.pdfbox.style.display = 'block'
          }, 10)
          setTimeout(() => {
            this.isDisabled = false
          }, 200)
        })
      },
      stepperOnchange2() {
        this.$nextTick(() => {
          // this.pdfStyle.width = this.percentValue
          this.pdfStyle2.transform = `scale(${this.value2})`
          this.imgStyle2.width = this.percentValue
          // 刷新pdf整体容器，解决IOS放大缩小后的样式混乱BUG
          this.$refs.pdfbox2.style.display = 'none'
          this.isDisabled2 = true
          setTimeout(() => {
            // 刷新pdf整体容器，解决IOS放大缩小后的样式混乱BUG
            this.$refs.pdfbox2.style.display = 'block'
          }, 10)
          setTimeout(() => {
            this.isDisabled2 = false
          }, 200)
        })
      },

      onLoad() {
        this.$api
          .post("/debt/member/agent/contract-list")
          .then(data => {
            // if (this.$route.query.identity === 'agent' && data.contract_status !== 1 && data.contract_status !== 2) {
            //   this.showDialog2 = true
            //   return
            // }
            this.agent_contract_status = data.agent_contract_status
            this.logo_contract_status = data.logo_contract_status
            this.contract_sign_time = data.contract_sign_time
            this.contract_due_time = data.contract_due_time
            this.logo_sign_time = data.logo_sign_time
            this.logo_due_time = data.logo_due_time
            this.agent_contract_id = data.agent_contract_id
            this.logo_contract_id = data.logo_contract_id
            this.is_backed = data.is_backed
            this.pdf_src_agent = data.agent_contract_url_signed || data.agent_contract_url_unsigned || data
              .agent_contract_url_images
            this.pdf_src_logo = data.logo_contract_url_signed || data.logo_contract_url_unsigned || data
              .logo_contract_url_images
            this.firstUrl = this.pdf_src_agent
            this.secondUrl = this.pdf_src_logo
            // 非图片形式则需要渲染pdf
            if (!(Array.isArray(this.pdf_src_agent) && this.pdf_src_agent.length > 0) && this.pdf_src_agent
              .startsWith('http')) {
              this.pdf_src_agent = pdf.createLoadingTask({
                url: this.pdf_src_agent,
                CMapReaderFactory
              });
              this.pdf_src_agent.promise.then(pdf => {
                this.num_pages_agent = pdf.numPages;
              })
            }
            if (!(Array.isArray(this.pdf_src_logo) && this.pdf_src_logo.length > 0) && this.pdf_src_logo.startsWith(
                'http')) {
              this.pdf_src_logo = pdf.createLoadingTask({
                url: this.pdf_src_logo,
                CMapReaderFactory
              });
              // console.log(this.pdf_src_logo,'this.pdf_src_logo')
              this.pdf_src_logo.promise.then((pdf) => {
                this.num_pages_logo = pdf.numPages;
              })
            }
            this.loading = false
          })
          .catch(err => {
            // console.log(err)
            // err.message && this.$toast(err.message)
            this.loading = false
          })
      },

      toSign(id, should) {
        this.$router.push({
          path: '/debtor/signContract',
          query: {
            // contract_id 可能是 agent_contract_id 或者 logo_contract_id
            contract_id: id,
            shouldSign: should, // or logo
            identity: 'agent',
            leavesigin: should == 'agent' ? '经纪人商标使用许可合同' : '解债经纪人合作协议'
          }
        })
      },
    }
  };
</script>

<style lang="less">
  .debtrelief-agent-contract-view {
    padding-top: 88px;

    .empty {
      width: 100%;
      height: 12px;
      background-color: #F5F6F7;
    }

    .content-box {
      padding-top: 13px;

      .note {
        width: 100%;
        text-align: center;
        height: 26px;
        font-size: 16px;
        color: #F9591B;
        line-height: 26px;
        margin-bottom: 15px;
      }

      .content1,
      .content2 {
        margin-bottom: 46px;

        .title {
          width: 100%;
          text-align: center;
          height: 29px;
          font-size: 18px;
          font-weight: 500;
          color: #333333;
          line-height: 29px;
          margin-bottom: 8px;
        }

        .preview {
          cursor: pointer;
          margin: 0 auto 12px;
          width: 130px;
          height: 175px;
          background: #F5F6F7;
          position: relative;

          .download-btn {
            font-weight: 400;
            font-size: 14px;
            color: rgba(18, 111, 255, 1);
            font-style: normal;
            letter-spacing: 0px;
            line-height: 20px;
            text-decoration: none;
            position: absolute;
            right: -45px;
            bottom: 0;
          }

          .icon {
            position: absolute;
            top: 0;
            right: 0;
            height: 21px;
            font-size: 13px;
            color: #FFFFFF;
            line-height: 21px;
            background: rgba(0, 0, 0, 0.6);
          }
        }

        .sign {
          display: block;
          width: 84px;
          margin: 0 auto 46px;
          padding: 4px 0;
          background: #FC740C;
          border-radius: 16px;
          border: none;
          height: 32px;
          font-size: 15px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 24px;
        }

        .signed {
          width: 100%;
          text-align: center;
          height: 26px;
          font-size: 16px;
          color: #999999;
          line-height: 26px;
          margin-bottom: 2px;
        }

        .validate {
          width: 100%;
          text-align: center;
          height: 26px;
          font-size: 16px;
          color: #999999;
          line-height: 26px;
          margin-bottom: 32px;
        }
      }

      .content2 {
        .title {}

        .preview {}

        .sign {}
      }
    }

    .van-popup {
      &::-webkit-scrollbar {
        display: none;
      }
    }

    .van-popup__close-icon {
      top: 44px;
    }

    .stepper-warpper {
      height: 28px;
      width: 100%;
      z-index: 9999;
      position: fixed;
      top: 44px;
      left: 50%;
      transform: translate(-50%);
      background-color: #fff;
      color: #000;

      .van-stepper {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }

      .percent {
        position: absolute;
        height: 28px;
        line-height: 28px;
        width: 40px;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        background-color: #f2f3f5;
        font-size: 13px;
      }
    }

    .loading {
      text-align: center;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);

      img {
        width: 35%;
        margin-top: 65%;
      }
    }

  }
</style>